import React from 'react';
import { m } from 'framer-motion';
import { Link } from 'react-router-dom';
import Footer from '../Footer/Footer';
import InfiniteCarousel from 'react-leaf-carousel';
import { Button } from 'components/Button/Button';

import './Home.scss';

import useNewsPosts from 'hooks/useNewsPosts';
import useBreakerCarousel from 'hooks/useBreakerCarousel';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/blur.css';

import breakerplaceholder from '../../assets/img/breaker-placeholder.png';
import join from '../../assets/img/joinus.jpg';

import egg1 from '../../assets/img/egg-step1.jpg';
import egg1video from '../../assets/img/egg-step1-video.mp4';
import egg2 from '../../assets/img/egg-step2.jpg';
import egg2video from '../../assets/img/egg-step2-video.mp4';

import hatcheningPoster from './assets/the-hatchening-poster.jpg';
import hatcheningVid from './assets/the-hatchening.mp4';

import gribbleHatchedPoster from './assets/hatch-gribble-poster.jpg';
import gribbleHatched from './assets/hatch-gribble.mp4';

import { formatDate } from 'utils/date';
import { routes } from '../../routing/routes';

export default function HatcheningHome() {
  const { homepageNewsPosts, isLoading } = useNewsPosts();
  const { breakers } = useBreakerCarousel();

  const joinimg = {
    background: 'url(' + join + ') no-repeat center center',
    backgroundSize: 'cover',
  };

  if (isLoading || !homepageNewsPosts) {
    return null;
  }

  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="home"
    >
      {/* ======================== New HERO Block */}

      <section
        className="
          has-bg d-flex flex-column p-0 justify-content-center height-100 mobile-height-auto
          "
      >
        <div className="is-video-bg center">
          <div className="video-bg-overlay center"></div>
          <video autoPlay loop controls={false} poster={hatcheningPoster} className="hatchening-bg">
            <source src={hatcheningVid} type="video/mp4" />
          </video>
        </div>

        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="hatchening-title-wrapper">
              <h1 className="text-center hatching-header">DuskBreakers: The Hatchening</h1>
              <div className="hatchening-title text-center">
                <p className="text-center body-large text-60">
                  Welcome to DuskBreakers, a Sci-Fi saga about a mysterious alien space vessel named
                  the Dusk, and its life-altering impact on the humans that explore it for resources
                  and riches.
                </p>
                <p className="text-center body-large text-60">
                  The alien Gribble Eggs have hatched. What once were thought of as a harmless
                  souvenir from the Dusk have become a craze across the city of Machafuko. How will
                  you manage your Gribbles?
                </p>
              </div>
              <Link className="text-center" to={routes.hatchening()}>
                <Button className="hatchening-button" primary>
                  Reveal Your Gribble
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ======================== Close New HERO Block */}
      {/* ======================== New HOW IT WORKS Block */}

      <section className="bg-black pt-5 pb-4">
        <div className="container-fluid">
          <div className="row">
            <div className="col">
              <h2 className="text-center mt-0 mb-4">Duskbreakers Explained</h2>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-12 col-md-4 mb-4 mb-lg-0">
              <div className="card h-100 m-0">
                <video autoPlay loop controls={false} alt="Mint" poster={egg1} muted playsInline>
                  <source src={egg1video} type="video/mp4" />
                </video>
                <div className="card-body h-100">
                  <p className="text-huge mb-2">Mint</p>
                  <p className="mt-2 text-60">
                    You can still mint your very own Gribble! Play either Twilight Shift or Beast
                    Battler to mint and reveal today.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 mb-4 mb-lg-0">
              <div className="card h-100 m-0">
                <video autoPlay loop controls={false} alt="Play" poster={egg2} muted playsInline>
                  <source src={egg2video} type="video/mp4" />
                </video>
                <div className="card-body">
                  <p className="text-huge mb-2">Play</p>
                  <p className="mt-2 text-60">
                    Play Twilight Shift and join your fellow Breakers aboard the Dusk as they
                    navigate the mysterious Red Warrens. Play, Break, & Survive!
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 mb-4 mb-lg-0">
              <div className="card h-100 m-0">
                <video
                  autoPlay
                  loop
                  controls={false}
                  alt="Grow"
                  poster={gribbleHatchedPoster}
                  muted
                  playsInline
                  className="hatch-video"
                >
                  <source src={gribbleHatched} type="video/mp4" />
                </video>
                <div className="card-body">
                  <p className="text-huge mb-2">Hatch</p>
                  <p className="mt-2 text-60">
                    The Gribbles are ready to hatch! The power to reveal is in your hands.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col pt-4">
              <p className="text-center">
                <Link className="text-center" to={routes.lore.base()}>
                  <Button>Explore DuskBreakers Lore</Button>
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ======================== Close HOW IT WORKS Block */}
      {/* ======================== UNDERHERO Block */}
      <section
        className="
            pt-4 underhero
          "
      >
        <div className="container-fluid">
          <div className="row pt-lg-0">
            <div className="col">
              <h2 className="text-center">Latest News</h2>
            </div>
          </div>

          <div className="row g-4">
            {homepageNewsPosts.slice(0, 4).map(({ id, title, imageUrl, publishDate, slug }) => {
              return (
                <div key={id} className="col-12 col-sm-6 col-lg-3">
                  <div className="linkcard card h-100 mb-0">
                    <LazyLoadImage
                      className="card-img-top"
                      alt={title}
                      src={imageUrl}
                      effect="opacity"
                    />
                    <div className="card-body">
                      <div className="text-small text-muted mb-2">
                        <span>{formatDate(publishDate)}</span>
                      </div>
                      <Link className="stretched-link" to={`/news/${id}/${slug}`}>
                        {title}
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="row">
            <div className="col">
              <p className="text-center pt-3 m-0">
                <a href={routes.news.base()}>View all news</a>
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* ======================== Close UNDERHERO Block */}

      {/* ======================== CAROUSEL Block */}
      <section className="has-bg">
        <InfiniteCarousel
          breakpoints={[
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              },
            },
          ]}
          dots={false}
          showSides={true}
          sidesOpacity={0.5}
          sideSize={0.1}
          slidesToScroll={1}
          slidesToShow={5}
          scrollOnDevice={true}
        >
          {breakers.map(({ id, name, imageUrl, isCanonBreaker }) => {
            return (
              <Link className="noline" key={id} to={`/gallery?breakerId=${id}`}>
                <figure>
                  <LazyLoadImage
                    className={`rounded breaker-carousel-img ${isCanonBreaker ? 'isCanon' : ''}`}
                    alt="Breaker in a gallery"
                    src={imageUrl}
                    placeholderSrc={breakerplaceholder}
                    effect="blur"
                  />
                  <figcaption className="text-small text-center text-muted pt-2">{name}</figcaption>
                </figure>
              </Link>
            );
          })}
        </InfiniteCarousel>

        <div className="container">
          <div className="row">
            <div className="col">
              <div className="mt-4">
                <h2 className="text-center">Genesis Breakers</h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="">
                <p className="text-center">
                  Our 10,000 Genesis NFT collection represents the first generation of DuskBreakers
                  in our universe. Learn more about them and their adventures on the Lore page.
                </p>

                <div className="d-flex justify-content-center pt-4">
                  <Link
                    className="btn btn-outline-primary me-4"
                    to={routes.lore.base()}
                    role="button"
                  >
                    Learn More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="is-bg stripes-top" />
      </section>
      {/* ======================== Close CAROUSEL Block */}

      {/* ======================== JOIN US Block */}
      <section
        className="
            height-60
            d-flex
            align-items-center
            justify-content-center
            has-bg
          "
      >
        <div className="container">
          <div
            className="
                row
                d-flex
                align-items-center
                justify-content-center
              "
          >
            <div className="col-lg-6 py-4">
              <h2 className="text-center">Join Us</h2>
              <p className="text-center">
                Join your fellow Breakers and friends for community events, giveaways, discussions,
                AMAs, and updates on the DuskBreakers world on{' '}
                <a target="_new" href="https://discord.gg/duskbreakers">
                  Discord
                </a>{' '}
                and{' '}
                <a target="_new" href="https://twitter.com/duskbreakers">
                  Twitter
                </a>
                !
              </p>
              <div className="pt-4 d-flex justify-content-center">
                <a
                  className="btn btn-primary"
                  role="button"
                  href="https://discord.gg/duskbreakers"
                  target="_new"
                >
                  Discord
                </a>
              </div>
            </div>
          </div>
          <div className="is-bg" style={joinimg} />
        </div>
      </section>
      {/* ======================== Close JOIN US Block */}

      <Footer />
    </m.main>
  );
}
